module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"fireskilled","short_name":"fireskilled","start_url":"/","background_color":"#2c2c33","theme_color":"#2c2c33","display":"standalone","icon":"src/images/fireskilled-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3b66403033c33b918c979c363e9ee6d3"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
